
import axios from 'axios'
import {addAPIV3Host, addHost} from '../Utils/urls';
export async function download(authToken, url, notify) {
    const callback = notify ? notify : ()=>{} //noop
    const config = {onDownloadProgress: progressEvent => {
        callback (progressEvent);
        },
        headers: {"X-Authorization": authToken}
    }
    try {
        return await axios.get(addAPIV3Host(url), config)
    }
    catch (e) {
        return e;
        //jsonResponse = '{"message": "' + e.message + '", "status": 500, "statusText": "Request failed" }';
    }
  }

export async function ssGetData(authToken, url) {
    return await axios.get(addAPIV3Host(url), authHeaders(authToken));
}
export function promiseData(url, authToken) {
    // debug json parsing errors
    /*
    let headers = authHeaders(authToken)
    headers.responseType = 'json'
    headers.transitional = {
        silentJSONParsing: false
    } */
    try {
        return axios.get(addAPIV3Host(url), authHeaders(authToken))
    }
    catch (err) {
        return err
    }
}
export function isPromise(o) {
    return typeof o?.then === 'function'
}
export async function getData(authToken, uri, hideAlert = false, host='APIV3') {
    let jsonResponse = '';
    //console.log (authHeaders(authToken));
    try {
        jsonResponse = await axios.get(addHost(uri, host), authHeaders(authToken));
    } 
    catch (e) {
        if (!hideAlert) alert(e.message);
        if (jsonResponse.length === 0)
            jsonResponse = '{"message": "' + e.message + '", "status": 500, "statusText": "Request failed" }';
    }
    finally {
        return jsonResponse;
    }
}

export async function getDataCancel(authToken, url, cancelToken, host) {
    let tokens = authHeaders(authToken);
    if (cancelToken) 
        tokens.cancelToken = cancelToken.token;
    try {
        return await axios.get(addHost(url, host), tokens);
    } 
    catch (e) {
        if (axios.isCancel(e)) {
            console.log('Request canceled', e.message);
        }
        else {
            console.log (e)
            throw (e)
        }
    }
}

export function getAPICancelToken() {
    return axios.CancelToken.source();
}

export async function putData(authToken, url, jsonData, hideAlert=true) {
    try {
        return await axios.put(addAPIV3Host(url), jsonData, authHeaders(authToken));
    } 
    catch (e) {
        if (!hideAlert) alert(e.message);
        return e
    }
}

export async function noauthPost(url, jsonData, hideAlert = false) {
    let jsonResponse = {};
    await axios.post(addAPIV3Host(url), jsonData, baseHeaders())
    .then ((response) => {
        jsonResponse = response.data;
        // console.log (response.status);
        return response;
    })
    .catch ((e) => {
        jsonResponse = e.response ? e.response.data : e;
        if (!hideAlert) alert(e.message);
        return e
    })
    return jsonResponse;
}
function hackityHack (jstring) {
    return jstring.replaceAll ('\\p', '')
}
function tryParse(jstring) {
    try {
        return JSON.parse(jstring)
    }
    catch {
        return JSON.parse(hackityHack(jstring))
    }
}
/* tested for error handling with c2 api. for error details use in .catch 
        console.log (e)
        if (e.response) {
            console.log(e.response.data, e.response.data.result.message);
            console.log (e.response.data.data.result.message)
            console.log(e.response.status);
            console.log(e.response.headers);
        }
 */
export async function postData(authToken, url, jsonData, host) {
    const jsonResponse = await axios.post(addHost(url, host), jsonData, authHeaders(authToken))
        .then ((response) => {
            return response;
        })
        .catch ((e) => {
            return e;
        }
    )
    return jsonResponse;
}

export async function deleteData(authToken, url, jsonData, hideAlert) {
    let jsonResponse = {};
    const headers = authHeaders(authToken);
    headers["data"] = jsonData;
    try {
        jsonResponse = await axios.delete(addAPIV3Host(url), headers)
    } 
    catch (e) {
        jsonResponse = e;
        if (!hideAlert) alert(e.message);
    }
    finally {
        return jsonResponse;
    }
}

function baseHeaders () {
    return {headers: {
        "Accept": "application/json",
        "Content-type": "application/json"}} 
}

function authHeaders(authToken) {
    var authHeader = baseHeaders();
    authHeader.headers["X-Authorization"] = authToken;
    return authHeader;
}

export function errorExtract(jsonResponse) {
    if (errorResponse(jsonResponse)) {
        return errorMessage(jsonResponse);
    }
    return null;
}

export function errorResponse (resp) {
    if (resp instanceof Error)
        return true;
    return resp && resp.hasOwnProperty("data") && resp.hasOwnProperty("message");
}
export function apiStatus (resp) {
    const ostatus = deepSearch (resp, 'status', (k,v)=>true)
    return ostatus?.status ? Number(ostatus.status) : undefined
}
export function errorMessage (jsonResponse) {
    if (jsonResponse instanceof Error) {
        const deep = nestedSearch(jsonResponse?.response, 'message')
        return deep?.message ?? jsonResponse?.message ?? jsonResponse?.data?.result?.message;
    }
    const obj = typeof jsonResponse === 'string' ? tryParse(jsonResponse) : jsonResponse
    if (apiStatus(obj) > 399) {
        const omsg = deepSearch(obj, 'message', (k,v)=>true)
        return omsg?.message
    }
    return null

/*    if (jsonResponse?.status && jsonResponse.status < 400)  // stop false positives
        return null
    if (Number(jsonResponse?.data?.status) < 400)
        return null
    const appErr = jsonResponse?.data?.data?.result?.message;
    if (appErr) return appErr;
    const netErr = jsonResponse?.message;
    return netErr */
}

function nestedSearch (object, key) {
    if (Object.hasOwn(object, key)) {
        return object
    }
    const nest = Object.keys(object)
    for (let i=0; i<nest.length; i++) {
        if ('object' === typeof (object[nest[i]])) 
            return nestedSearch(object[nest[i]], key)
    }
    return undefined
}
function  deepSearch (object, key, predicate) {
    if (object.hasOwnProperty(key) && predicate(key, object[key]) === true) return object
  
    for (let i = 0; i < Object.keys(object).length; i++) {
      let value = object[Object.keys(object)[i]];
      if (typeof value === "object" && value != null) {
        let o = deepSearch(object[Object.keys(object)[i]], key, predicate)
        if (o != null) return o
      }
    }
    return null
  }
  
export async function apiData (authToken, url) {
    return getData(authToken, url);
}

export async function login (name, pwd, setLoginState)
{
    const apiResp = await axios.post(addAPIV3Host('/auth/login?platform_type=Web'), 
        {"username":name,
        "password":pwd}
    )
    .then (function (response) {
        return response
    })
    .catch((error) => {
        return error
    });
    if (apiResp?.data?.token) {
        const token = apiResp.data;
        setLoginState(name, 'Bearer ' + token.token);
    }
    return apiResp;
}
